import apiInstance from "./axios";
import { review } from "utils/services/api/schemas";

const reviewApi = {
  getReviewById: async (id, userId) => {
    const response = await apiInstance.get(`${review}/${id}`, { userId });
    return response;
  },
  createReview: async (payload) => {
    const response = await apiInstance.post(review, payload);
    return response;
  },
};

export default reviewApi;
